var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"chevron-arrow"},_vm._l((Array(2)),function(i){return _c('span',{key:i,staticClass:"wing",style:({ background: _vm.background })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }